export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-format/src/identity.js
// module id = ../../../../d3-format/src/identity.js
// module chunks = 4